module.exports = __webpack_public_path__ + "static/img/check-data.4fe1adb.jpg";